const shopDictEN = {
  seeProduct: "See product",
  firstBannerText: "The marketplace that always rewards you",
  secondaryBannerText: "Join the Extraconomy",
  secondaryBannerButtonText: "Discover our plans",
  secondaryBannerText2: "Increase your economic power",
  searchQueryText: "You searched for: ",
  subCategoryFilter: "Subcategories",
  noProductsInCategory: "Has no products here",
  noProductsInSearch: "No products found",
  noSubcategories: "Has no subcategories",
  filters: "Filters",
  downloadable: "Downloadable",
  brazil: "Brazil",
  mexico: "Mexico",
  italy: "Italy",
  brl: "BRL",
  mxn: "MXN",
  eur: "EUR",
  usd: "USD",
  gbp: "GBP",
  try: "TRY",
  results: "Results",
  result: "Result",
  selectStore: "Select a store",
  store: "Store",
  filter: "Filter",
  registerAsCustomerFree: "Register as a Customer for free",
  register2: "Register",
  selectCategory: "Select the Department",
  allDepartments: "All Departments",
  departments: "Departments",
  discoverAllDepartments: "Discover all our departments",
  seeBellowAllDepartments:
    "See below all our departments available in the store and filter products by the department you prefer",
  linkCopied: "Link copied",
  errorCopyingLink: "Error copying link",
  sharedSuccessfully: "Shared successfully",
  sharingCanceled: "Sharing canceled",
  errorSharing: "Error sharing",
  findPartnersNearYou: "Find Extraconomy partners near you",
  useOurMap:
    "Discover companies, services and products that make up the new cooperative economy. Use the map to find nearby partners, take advantage of benefits and move financial circularity around you.",
  buyLocally:
    "Buy from nearby partners, strengthen the local economy, accumulate rewards and participate in a more equitable network for all.",
  value: "Value",
  bank: "Bank",
  transferToThisBank: "You must make the transfer with the following data:",
  fringeBenefits: "Fringe Benefits",
  readMore: "Read more",
};

export default shopDictEN;
